import React, { Fragment } from 'react';
import HeroRideSafe from 'shared/lib/assets/img/landing/hero-ridesafe.png';
import LogoChubb from 'shared/lib/assets/img/logo/logo-chubb.svg';
import map from 'lodash/map';
import styles from './index.module.css';
import logoUberLyft from './assets/logo-uber-lyft.png';

import CloudArrow from './assets/cloud_arrow.svg';
import CircleArrows from './assets/circle_arrows.svg';
import CircleCheck from './assets/circle_check.svg';

function CustomFirstSection() {
  const setupSteps = [
    {
      iconImage: CloudArrow,
      memo: <Fragment>Download the Sure app</Fragment>,
    },
    {
      iconImage: CircleArrows,
      memo: (
        <Fragment>
          Connect your Uber<sup>®</sup> and Lyft apps on your phone
        </Fragment>
      ),
    },
    {
      iconImage: CircleCheck,
      memo: (
        <Fragment>
          You’re set. Coverage activates automatically when you ride Uber
          <sup>®</sup> or Lyft
        </Fragment>
      ),
    },
  ];

  const renderSetupSteps = (step, i) => (
    <div className={styles.ridesafe_setup_step} key={step.fontAwesomeClassName}>
      <div className={styles.ridesafe_setup_step_iconWrapper}>
        <img
          src={step.iconImage}
          className={styles.ridesafe_setup_step_icon}
          alt={`Step ${i + 1}`}
        />
      </div>
      <p className={styles.ridesafe_setup_step_memo}>{step.memo}</p>
    </div>
  );

  return (
    <section className={styles.ridesafe_section}>
      <div className={styles.ridesafe_setup}>
        <div className={styles.ridesafe_setup_textWrapper}>
          <h1 className={styles.ridesafe_setup_heading}>
            Set up RideSafe™ for Uber<sup>®</sup> or Lyft rides
          </h1>
          <p className={styles.ridesafe_setup_subheading}>
            Once you sign up, we’ve got you covered: RideSafe™ syncs with your
            rideshare accounts, like Uber<sup>®</sup> and Lyft, and is
            automatically set up every time you order a car.
            <br />
            Get yours:
          </p>
          <img
            className={styles.ridesafe_setup_logoUberLyft}
            src={logoUberLyft}
            alt="Uber and Lyft wordmarks"
          />
          <p className={styles.ridesafe_setup_footer}>
            Autonomous Cars (coming soon) <br />
            Bike Sharing (coming soon) <br />
            Electric Scooter Sharing (coming soon)
          </p>
        </div>
        <div className={styles.ridesafe_setup_stepsWrapper}>
          <div className={styles.ridesafe_setup_stepsNumbersWrapper}>
            <div className={styles.ridesafe_setup_stepsNumber}>1</div>
            <div className={styles.ridesafe_setup_stepsVerticalLine} />
            <div className={styles.ridesafe_setup_stepsNumber}>2</div>
            <div className={styles.ridesafe_setup_stepsVerticalLine} />
            <div className={styles.ridesafe_setup_stepsNumber}>3</div>
          </div>
          <div className={styles.ridesafe_setup_stepsItemsWrapper}>
            {map(setupSteps, renderSetupSteps)}
          </div>
        </div>
      </div>
    </section>
  );
}

export const rideSafeConfig = {
  hero: {
    heading: 'Insure Your Uber® or Lyft Everytime You Ride',
    subheading:
      'Whether it’s a spinout on an icy stretch or a distracted driver running a red light, RideSafe™ Rideshare Insurance by SURE provides additional protection for passengers and their families when they use services like Uber®, Lyft, and others coming soon.',
    cta: 'Get RideSafe™ insurance',
    ctaLink: '/ridesafe-rideshare-insurance',
    CustomCTA: null,
    img: HeroRideSafe,
  },
  underwriter: {
    img: LogoChubb,
    name: 'Chubb',
  },
  CustomFirstSection: <CustomFirstSection />,
  coverageDetails: [
    {
      heading: 'Medical Costs',
      subheading:
        'RideSafe™ Rideshare Insurance can help you connect the spaces that medical insurance leaves open, giving you cash payments to cover your out-of-pocket expenses.',
    },
    {
      heading: 'Severe Injury',
      subheading:
        'Sometimes awful injuries happen when you’re in an accident. You’ll receive thousands of dollars to help cover expenses so you can focus on recovery.',
    },
    {
      heading: 'Loss of life',
      subheading:
        'No one wants to think about the worst happening, but if it does, your family will be covered up to $100,000 in the event of your death.',
    },
  ],
  scenarioDetails: {
    heading: 'Why Would You Need RideSafe™ Insurance?',
    scenarios: [
      {
        heading: 'Scenario 1',
        subheading:
          'Your Lyft car is rear-ended and you arrive at your destination with some cuts and bruises.',
      },
      {
        heading: 'Scenario 2',
        subheading:
          'Your disgruntled driver gets physical with you, resulting in injuries and hospital bills.',
      },
      {
        heading: 'Scenario 3',
        subheading:
          'You and your driver were invloved in a fender bender and walked away with barely a scrape. Your phone— not so much.',
      },
    ],
  },
  comparison: [
    'Instant quote',
    'Buy and manage your policy in one place',
    'Insurance explained in simple, easy-to-digest way',
    'Mobile',
    'Endorsements',
    'Plan tailored to fit your needs',
  ],
};
